export const getRedirectUrl = (baseUrl: string) => {
  const isHarbourClub = localStorage.getItem("isHarbourClub") === "true";
  const isBiz4Biz = localStorage.getItem("isBiz4Biz") === "true";

  if (isHarbourClub) {
    return `${baseUrl}?via=harbour`;
  }
  if (isBiz4Biz) {
    return `${baseUrl}?via=biz4biz`;
  }
  return baseUrl;
};
